require('webpack-jquery-ui/selectmenu');
require('webpack-jquery-ui/datepicker');
#require("../app/form.coffee")
require("../app/gratitude_block.coffee")
require("../app/feedback_form.coffee")

window.pageInitFlag = false

pageInit = ->
  new window.FeedbackForm()
  new window.Gratitude()

$(document).ready ->
  if window.pageInitFlag == false
    pageInit()
  window.pageInitFlag = true


// WEBPACK FOOTER //
// ./assets/javascripts/pages/virtual_reception.coffee